import {
  PauseIcon_default
} from "./chunk-GCI6ADGL.mjs";
export {
  PauseIcon_default as default
};
